<template>
    <div class="row props-group">
        <el-form-item label="显示行数">
          <el-input/>
        </el-form-item>
    </div>
</template>

<script>
export default {
  name: 'attr-row',
  data () {
    return {
    }
  },
  methods: {

  }
}
</script>

<style>
  .row{
    border-top: 1px solid #ebebeb;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/row.vue